<div class="side-navigation-view">
  <side-navigation-base-menu
    [config]="config"
    [updateLocationParam]="updateLocationParam"
    (onTabClick)="onTabClick.emit($event)"
    (onBackClick)="onBackClick.emit($event)"
    (onHidden)="hiddenSideNavigation = $event; onHiddenSideNavigation.emit($event)"
    #sideNavigationBaseMenuComponent
  />

  <div
    class="side-navigation-view__content"
    [ngClass]="{ 'side-navigation-view__content--sidenav-hidden': hiddenSideNavigation }"
  >
    <ng-content></ng-content>
  </div>
</div>
